export const adiquimicaConfiguration = {
  adiquimica_configurations: `Adiquimica configurations`,
  connected_databases: `Connected databases`,
  "add_single_or_multiple_database(s)_by_pressing_enter": `Add single or multiple database(s) by pressing enter`,
};
